














import { ExportApi } from "../../api/ExportApi";
import { Export } from "../../models/Export";

// Intervalle de polling du statut et délai au-delà duquel on abandonne.
const POLL_INTERVAL = 3 * 1000;
const POLL_TIMEOUT = 10 * 60 * 1000;

export default {
    name: "ExportButton",
    props: {
        type: {
            type: String,
            required: true,
        },
        // Objet de paramètres, ou fonction qui le retourne (évaluée au clic).
        params: {
            type: [Object, Function],
            default: null,
        },
        icon: {
            type: String,
            default: "fal fa-file-excel",
        },
        title: {
            type: String,
            default: "Exporter",
        },
        label: {
            type: String,
            default: "",
        },
        buttonClass: {
            type: String,
            default: "btn-default",
        },
    },
    data() {
        return {
            exporting: false,
            waitingModalVisible: false,
            timer: null,
            ExportApi: new ExportApi(),
        };
    },
    computed: {
        // Certains exports sont réservés aux administrateurs (le backend refuse
        // aussi ces types pour les autres utilisateurs).
        visible() {
            return !Export.requiresAdmin(this.type) || this.$isAdmin;
        },
    },
    methods: {
        startExport() {
            let self = this;

            if (self.exporting) {
                return;
            }

            let params =
                typeof self.params === "function" ? self.params() : self.params;

            self.exporting = true;
            self.openWaitingModal();

            self.ExportApi.create(self.type, params || {})
                .then(function (exportItem) {
                    self.pollStatus(exportItem.id);
                })
                .catch(function () {
                    self.stopPolling();
                    self.showError();
                });
        },
        openWaitingModal() {
            let self = this;

            self.waitingModalVisible = true;

            swal({
                title: "Export en cours",
                text:
                    "Le fichier est en cours de génération, le téléchargement démarrera automatiquement.\n" +
                    "Ne fermez pas cette fenêtre pour ne pas interrompre l'export.",
                showConfirmButton: false,
            }).catch(function () {
                // Fermée à la main : l'attente continue via le spinner du bouton.
                self.waitingModalVisible = false;
            });

            swal.showLoading();
        },
        closeWaitingModal() {
            if (this.waitingModalVisible) {
                this.waitingModalVisible = false;
                swal.close();
            }
        },
        pollStatus(exportId) {
            let self = this;
            let startedAt = Date.now();

            self.timer = setInterval(function () {
                if (Date.now() - startedAt > POLL_TIMEOUT) {
                    self.stopPolling();
                    self.showError();
                    return;
                }

                self.ExportApi.get(exportId)
                    .then(function (exportItem) {
                        if (exportItem.status === Export.STATUS.SUCCESS) {
                            self.stopPolling();
                            self.closeWaitingModal();
                            self.ExportApi.download(
                                exportId,
                                exportItem.filename
                            ).catch(
                                function () {
                                    self.showError();
                                }
                            );
                        } else if (exportItem.status === Export.STATUS.ERROR) {
                            self.stopPolling();
                            self.showError();
                        }
                    })
                    .catch(function () {
                        self.stopPolling();
                        self.showError();
                    });
            }, POLL_INTERVAL);
        },
        stopPolling() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.exporting = false;
        },
        showError() {
            // Ouvrir le swal d'erreur remplace la modale d'attente encore ouverte.
            this.waitingModalVisible = false;
            swal("Erreur", "L'export a échoué. Veuillez réessayer.", "error");
        },
    },
    destroyed() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.closeWaitingModal();
    },
};
